import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@services';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const PhoenixOktaInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.phoenix.url;
    const authService = inject(AuthService);

    if (urlToMatch && req.url.startsWith(urlToMatch)) {
        const clone = cloneAndAddHeaders(req, {
            Authorization: `Bearer ${authService.accessToken}`,
            'csdt-authorization-app': csdtAuthApp,
            'Content-Type': 'application/json',
        });
        console.debug('[Interceptors][PhoenixOktaInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
